import { CheckCircle2, AlertTriangle, Lightbulb } from "lucide-react";

const BLOCKS = [
  { key: "punti_forza", title: "Punti di forza", icon: CheckCircle2, cls: "text-emerald-400" },
  { key: "rischi", title: "Rischi principali", icon: AlertTriangle, cls: "text-rose-400" },
  { key: "suggerimenti", title: "Suggerimenti e pivot", icon: Lightbulb, cls: "text-amber-400" },
];

export const IdeaInsights = ({ idea }) => {
  if (!idea.punti_forza) return null;
  return (
    <div className="grid md:grid-cols-3 gap-4" data-testid="idea-insights">
      {BLOCKS.map(({ key, title, icon: Icon, cls }) => (
        <div key={key} className="rounded-2xl bg-[#12141F] border border-white/[0.07] p-5" data-testid={`insights-${key}`}>
          <div className={`flex items-center gap-2 font-display font-semibold ${cls}`}>
            <Icon className="w-4 h-4" /> {title}
          </div>
          <ul className="mt-3 space-y-2">
            {(idea[key] || []).map((t) => (
              <li key={t} className="text-sm text-slate-300 leading-relaxed">{t}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
